<template>
  <router-link :to="{ name: consts.ROUTE_MODULES_INDEX }">
    <slot></slot>
  </router-link>
</template>

<script>
import { ROUTE_MODULES_INDEX } from "Consts/publicRoutes";

export default {
  name: "LogoRouter",
  data() {
    return {
      consts: { ROUTE_MODULES_INDEX },
    };
  },
};
</script>

<style scoped></style>
